import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const HeaderContact = ({ clang }) => {
    return (
        <div className="header__contact">
            <Link to={`/about/contact`} className="header__contact-link" title={lang[clang].header.contact}>
                {lang[clang].header.contact}
            </Link>
        </div>
    );
};

HeaderContact.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeaderContact);



// WEBPACK FOOTER //
// ./src/components/header/HeaderContact.js